// Imports
import MicroModal from "micromodal";

class Modal {
    constructor() {
    }
    init() {
        MicroModal.init({
            openClass: '_open', // Custom class to be applied when modal is open
            openTrigger: 'data-modal-open', // Custom data attribute to open modal
            closeTrigger: 'data-modal-close', // Custom data attribute to close modal
            onShow: (modal, trigger, event) => {
                // This is fired when the modal is opening.

                // Get trigger or target element based on where Safari or not
                let trig = trigger ? trigger : event.target;

                // Disable scrolling
                window.APP.modules.PageScrolling.lock(modal);

                const modalContent = modal.querySelector('.modal-content');
                let btn = document.getElementById(trig.id);

                if (!modalContent) {
                    console.error('Element with class .modal-content not found');
                }
                if (!btn) {
                    console.error('btn element not found with ID: ' + trig.id);
                }

                let imageSettings = btn.hasAttribute('data-image') ? btn.getAttribute('data-image') : null;
                let videoSettings = btn.hasAttribute('data-video') ? btn.getAttribute('data-video') : null;

                console.log({videoSettings});

                // Image
                if (imageSettings) {
                    // Create image element
                    const img = document.createElement('img');

                    // Add a class to the image
                    img.classList.add('object-contain h-full w-full');

                    // Add the image URL to the
                    img.src = imageSettings;

                    // Append the iframe to the modal content if the element exists
                    if (modalContent) {
                        modalContent.appendChild(img);
                    }
                }

                // Video
                if (videoSettings) {
                    // Create iframe element
                    let iframe = document.createElement('iframe');

                    // Add a class to the iframe
                    iframe.classList.add('reframe', 'aspect-video', 'h-auto', 'w-full');

                    // Set attributes
                    iframe.setAttribute('frameborder', '0');
                    iframe.setAttribute(
                        'allow',
                        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen;'
                    );
                    iframe.setAttribute('allowfullscreen', '');

                    // Split the videoSettings string by a comma
                    let [videoType, videoID] = videoSettings.split(',');
                    let videoUrl = '';

                    if (videoType === 'vimeo') {
                        videoUrl = `https://player.vimeo.com/video/${videoID}?title=0&byline=0&portrait=0&controls=1&autoplay=1`;
                    }
                    else if (videoType === 'youtube') {
                        videoUrl = `https://www.youtube.com/embed/${videoID}?showinfo=0&rel=0&iv_load_policy=3&start=0&controls=1&autoplay=1`;
                    }

                    // Add URL to iframe
                    iframe.src = videoUrl;

                    // Append the iframe to the modal content if the element exists
                    if (modalContent) {
                        modalContent.appendChild(iframe);
                    }
                }
            },
            onClose: modal => {
                //This is fired when the modal is closing.
                // The function receives the modal object as the first parameter and the trigger element as the second parameter.

                let modalContent = modal.querySelector('.modal-content');
                if (modalContent) {
                    modalContent.innerHTML = ''; // Remove content
                }

                // Enable scrolling
                window.APP.modules.PageScrolling.unlock(modal);
            }
        });
    }
}

export default new Modal();



